import type { FinanceQueueLifecycle } from '@/components/Financeiro/financeQueueLifecycle'

export function buildGestoresChamadosReturnQuery(input: {
  lifecycle: FinanceQueueLifecycle
  area: string
  search: string
}) {
  const params = new URLSearchParams()
  params.set('tab', 'chamados')
  params.set('chLifecycle', input.lifecycle)
  if (input.area) params.set('chArea', input.area)
  if (input.search.trim()) params.set('chSearch', input.search.trim())
  return params.toString()
}
